
import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { fetchUserAttributes } from 'aws-amplify/auth';

const UserProfile = ({ mode }) => {
    const [userAttributes, setUserAttributes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function getUserAttributes() {
            try {
                const attributes = await fetchUserAttributes();
                setUserAttributes(attributes);
                setLoading(false);
            } catch (error) {
                console.log('error fetching user info:', error);
                setError(error);
                setLoading(false);
            }
        }

        getUserAttributes();
    }, []);

    if (loading) {
        return <p>Loading user profile...</p>;
    }

    if (error) {
        return <p>Error loading profile: {error.message}</p>;
    }

    return (
        <div>
            <Typography variant="subtitle1" component="p">
                Welcome <span style={{
                    fontStyle: 'italic',
                    color: mode === 'light' ? '#276ef1' : '#90caf9'
                }}>{userAttributes.preferred_username || userAttributes.sub}</span>!
            </Typography>
        </div>
    );
};

export default UserProfile;
